export const dashboardTour = [
  {
    target: '[data-tour="dashboard-welcome"]',
    title: "Welcome to AccessWealth",
    description:
      "This dashboard gives you a live overview of your financial future.",
  },

  {
    target: '[data-tour="add-asset-button"]',
    title: "Add Your Assets",
    description:
      "Start by adding your bank accounts, stocks, mutual funds, gold, properties and more.",
  },

  {
    target: '[data-tour="networth-card"]',
    title: "Track Net Worth",
    description:
      "Your net worth updates automatically as you add assets and liabilities.",
  },

  {
    target: '[data-tour="liabilities-section"]',
    title: "Liability Forecast",
    description:
      "Understand how loans and EMIs affect your long-term financial health.",
  },

  {
    target: '[data-tour="goals-section"]',
    title: "Financial Milestones",
    description:
      "AccessWealth predicts future wealth milestones and financial progress.",
  },
  {
    id: "tour-complete",
    target: '[data-tour="add-asset-button"]',
    title: "You're Ready to Go",
    description:
      "You now have a complete overview of AccessWealth. Feel free to explore the platform, add your assets, liabilities, goals and nominees at your own pace. If you need help or have any questions, our team is always here to assist you.",
  },
];
